import React from 'react';
import PropTypes from 'prop-types';
import StatusBar from './StatusBar';

const propTypes = {
    activeId: PropTypes.number.isRequired,
    isNewUser: PropTypes.bool
};

const newUserItem = {
    id: 0,
    icon: 'profile',
    label: 'Identity',
    status: 'complete'
};

let items = [
    {
        id: 1,
        icon: 'gear',
        label: 'Account'
    },
    {
        id: 2,
        icon: 'envelope',
        label: 'Email'
    },
    {
        id: 3,
        icon: 'lock',
        label: 'Security'
    },
    {
        id: 4,
        icon: 'dog-earred',
        label: 'Review'
    }
];

function StatusBarContainer(props) {
    if (props.isNewUser === true) {
        items.unshift(newUserItem);
    }

    for (var i = 0; i < items.length; i++) {
        if (items[i].id < props.activeId) {
            items[i].status = 'complete';
        } else if (items[i].id === props.activeId) {
            items[i].status = 'current';
        } else {
            items[i].status = '';
        }
    }

    return <StatusBar items={items} />;
}

StatusBarContainer.propTypes = propTypes;
export default StatusBarContainer;
